import { makeStyles } from '@mui/styles';
import { CustomTheme } from 'types/theme';

export const useStyles = makeStyles((theme: CustomTheme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 18,
    marginTop: 30
  },
  emailLabel: {
    '&.MuiTypography-root': {
      color: theme.palette.text.secondary,
      fontSize: 11,
      fontWeight: 700,
      lineHeight: '18px',
      letterSpacing: 0.5
    }
  },
  email: {
    '&.MuiTypography-root': {
      fontSize: 14,
      lineHeight: '20px',
      letterSpacing: 0.15
    }
  },
  buttonContainer: {
    marginTop: 20,
    display: 'flex',
    justifyContent: 'space-between'
  }
}));
